import axios from '../../axios';

export default {

  namespaced: true,

  state: {},
  getters: {},
  mutations: {},

  actions: {

    // response object contains = {userId,signUpDate,purchaseCount,email,ids_Villas}
    getFormSubmitData({ }, data) {
      return new Promise((resolve, reject) => {
        // data = {contactId: 0, shortListVillaIds: [1,2]}
        axios.post('/core/googledatalayer/formsubmit', data).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },

    // response object contains = {id_Property,country,think_Exquisite,adults,children,babies,rating}
    getBookingCheckoutData({ }, bookingId) {
      return new Promise((resolve, reject) => {
        // data = {contactId: 0, shortListVillaIds: [1,2]}
        axios.get(`/core/googledatalayer/bookingcheckout/${bookingId}`).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },

    // response object contains = {id_villa,title,destination,area,country,sleeps,bedrooms,bathrooms,image_fullsize,image_thumbnail,pdf,description,description_long,rating,ratings_count,url,think_exquisite,amenities}
    getVillaPageData({ }, villaId) {
      return new Promise((resolve, reject) => {
        // data = {contactId: 0, shortListVillaIds: [1,2]}
        axios.get(`/core/googledatalayer/villapage/${villaId}`).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },

  },

};
